import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { adornmentType } from 'components/_basic/Form/TextInput/TextInput/types';
import { PRODUCTION_PLANS_FIELDS_NUMBER } from 'components/BusinessToolForm/constants/fieldsNumber';
import { PRODUCT_NAMES } from 'components/BusinessToolForm/Sections/Global/general/products';

import { concatWithDot } from 'helpers/string';

import { adornmentIconMap } from './constants';
import { IProductVolumeInputFieldProps } from './types';

export const ProductVolumeInputField: FC<IProductVolumeInputFieldProps> = ({ name, disabled }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const volumeInType = useWatch({ name: concatWithDot(name, PRODUCT_NAMES.VOLUME_UNITS) });

  const fieldName = concatWithDot(name, PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL);

  return (
    <NumberInputControlled
      control={control}
      adornmentType={volumeInType}
      id={fieldName}
      name={fieldName}
      disabled={disabled}
      label={t('businessOperations.production.productVolume.monthlyVolume')}
      endAdornmentIcon={adornmentIconMap[volumeInType as adornmentType]}
      data-mirror-field={concatWithDot(
        name,
        `${PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL}.${PRODUCTION_PLANS_FIELDS_NUMBER}`,
      )}
    />
  );
};
